import React from 'react';
import { Card, Typography, Space, Tag, Divider, Row, Col } from 'antd';
import { InfoCircleOutlined, DatabaseOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const SystemInfo: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <DatabaseOutlined style={{ marginRight: 8 }} />
              System Information
            </Title>
            <Tag color="cyan">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>System Overview</Title>
            <Paragraph>
              This page will display comprehensive system information and status.
              Features will include:
            </Paragraph>
            
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Card size="small" title="System Status">
                  <ul>
                    <li>Server health and performance</li>
                    <li>Database connection status</li>
                    <li>Memory and CPU usage</li>
                    <li>Network connectivity</li>
                  </ul>
                </Card>
              </Col>
              <Col span={12}>
                <Card size="small" title="Version Information">
                  <ul>
                    <li>Application version details</li>
                    <li>Database schema version</li>
                    <li>API version information</li>
                    <li>Last update timestamps</li>
                  </ul>
                </Card>
              </Col>
            </Row>
          </div>
          
          <div style={{ 
            background: '#e6f7ff', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #91d5ff'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#1890ff' }} />
              <Text type="secondary">
                System monitoring and information features are being developed for better system management.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default SystemInfo;
